<template>
    <div class="cart">
        <img @click="cartObj" class="cart-left" src="../../assets/img/left__svg.svg" alt="">
        <div class="cart__top">
            <ul class="cart__top-list">
                <li class="cart__top-list__li" @click="titleFilter">Odatiy</li>
                <li class="cart__top-list__li" @click="titleFilter('title')">Ism</li>
                <li class="cart__top-list__li" @click="titleFilter('price')">Narxi</li>
            </ul>
            <form>
                <input type="text" v-model="inputSearch" class="cart__top-input" placeholder="Qidirish">
            </form>
        </div>
        <div class="cart__main">
            <div class="cart__main-card" v-for="(one, i) in cartFilter" :key="i">
                <img :src="one.img" alt="">
                <h2>{{ one.title }}</h2>
                <p><span>{{ one.price * one.amount }}</span>sum</p>
                <div v-if="one.amountBool" class="cart__main-card__info">
                    <button class="cart__main-card__info-btn" @click="modalInfo(one.img, one.title, one.price,)">Xarid
                        qilish</button>
                    <div class="cart__main-card__info-btns">
                        <button>
                            <img v-if="one.heartFill" src="../../assets/img/card__heart1.svg" alt=""
                                @click="addHeart(one.id, one.img, one.title, one.price)">
                            <img v-else class="tavar__one-info__card-info__imgs-heart" src="../../assets/img/heart.svg"
                                alt="" @click="$emit('heartFill', one.id)">
                        </button>
                        <button>
                            <img src="../../assets/img/card__shop.svg" alt=""
                                @click="addCart(i, one.id, one.img, one.title, one.price, one.amount)">
                        </button>
                    </div>
                </div>
                <div class="tavar__one-info__card-summa" v-else>
                    <span @click="amounMath('-', i, one.id)">-</span>
                    <p>{{ one.amount }}</p>
                    <span @click="amounMath('+', i, one.id)">+</span>
                </div>
            </div>
            <h2 v-if="cartFilter.length == 0" style="font-weight:400;">{{ cartNone }}</h2>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        tOne: Array,
        navH: Boolean,
        OneFilter: String,
        modalBool: Boolean,
    },
    data() {
        return {
            inputSearch: "",
            cartNone: 'Malumot Topilmadi ?',
            filterCartOne: []
        }
    },
    methods: {
        addCart(i, id, img, title, price, amount) {
            this.cartFilter.forEach((one, index) => {
                if (i == index) {
                    one.amountBool = false
                }
            });
            this.$emit('addCart', {
                id: id,
                img: img,
                title: title,
                price: price,
                amount: amount
            })
        },
        amounMath(plusOrMinus, i, id) {
            this.cartFilter.forEach((one, index) => {
                if (i == index) {
                    if (plusOrMinus == '-') {
                        if (one.amount > 1) {
                            one.amount--
                            this.$emit('tMinus', {
                                id: id,
                                amount: one.amount
                            })
                        }
                        else {
                            one.amountBool = true
                            this.$emit('delCart', id)
                        }
                    }
                    else if (plusOrMinus == '+') {
                        one.amount++
                        this.$emit('tPlus', {
                            id: id,
                            amount: one.amount
                        })
                    }
                }
            });
        },
        addHeart(id, img, title, price) {
            this.$emit('addHeart', {
                id: id,
                img: img,
                title: title,
                price: price
            })
        },
        cartObj() {
            this.$emit('cartObj', {
                bool: false
            });
        },
        modalInfo(img, title, price,) {
            this.$emit('modalBool', {
                bool: true,
                obj: {
                    img: img,
                    title: title,
                    price: price
                }
            })
        },
        titleFilter(val) {
            if (val == 'title') {
                this.cartFilter.sort((a, b) => {
                    if (a.title > b.title) {
                        return 1
                    }
                    if (a.title < b.title) {
                        return -1
                    }
                })
            }else if (val == 'price'){
                this.cartFilter.sort((a,b)=>a.price - b.price)
            }else{
                this.cartFilter.sort((a,b)=>a.id - b.id)
            }
        }
    },
    mounted() {
        let cartMain = document.querySelector('.cart__main');
        window.addEventListener("scroll", (el) => {
            if (window.scrollY > 170) {
                cartMain.style = `margin-top: ${this.navH}px;`
            } else {
                cartMain.style = `margin-top: 0;`
            }
        });
    },
    computed: {
        cartFilter() {
            this.filterCartOne = this.tOne.filter(cart => cart.filter == this.OneFilter)
            let searchOne = this.inputSearch
            if (!searchOne) return this.filterCartOne;
            searchOne = searchOne.trim().toLowerCase();
            this.filterCartOne = this.filterCartOne.filter((note) => {
                if (note.title.toLowerCase().indexOf(searchOne) != -1) return note;
            });
            return this.filterCartOne;
        },
    }
}
</script>
<style lang="scss">

</style>